import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
const { change } = actions;
import { VideoScreen } from './VideoScreen';
import withFeatureToggling from '../../../hocs/withFeatureToggling/withFeatureToggling';
import { clientDefiniteKO } from 'actions/identityValidationActions';
import { startPolling, stopPolling } from 'actions/polling';

const mapStateToProps = state => ({
    userProfile: state.userProfile,
    video: state.video,
});

const mapDispatchToProps = {
    change,
    clientDefiniteKO,
    startPolling,
    stopPolling,
};

export const VideoScreenContainer = connect(mapStateToProps, mapDispatchToProps)(withFeatureToggling(VideoScreen));
